import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/service/index.service';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';

@Component({
  selector: 'app-pago-success',
  templateUrl: './pago-success.component.html',
  styleUrls: ['./pago-success.component.scss']
})
export class PagoSuccessComponent implements OnInit {
  referencia: string | null = null;
  status: string | null = null;
  type: string | null = null;
  transactionId: string | null = null;
  fecha: string = new Date().toLocaleString('es-AR');
  detalleVenta: any = null;

  constructor(private route: ActivatedRoute, private wsdl: ApiService) { }

  async ngOnInit() {
    // Obtener la referencia desde la ruta
    this.referencia = this.route.snapshot.paramMap.get('id');

    // Obtener los parámetros de Unicobro (?status=...&type=...&transactionId=...)
    this.route.queryParams.subscribe(async (params) => {
      this.status = params['status'] || null;
      this.type = params['type'] || null;
      this.transactionId = params['transactionId'] || null;

      // Determinar el estado a guardar en la base
      let estado = 'pendiente';

      if (this.status === '200') {
        estado = 'pagada';
      } else if (this.status === '400' || this.status === '500' || this.status === 'failed') {
        estado = 'rechazado';
      }

      // Actualizar en backend solo si hay referencia válida
      if (this.referencia) {
        try {
          const data = await this.wsdl.actualizarVenta(estado, this.referencia);
          const result = JSON.parse(JSON.stringify(data));

          if (result.code == 200) {
            this.detalleVenta = result.data;
            UturuncoUtils.showToas(result.msg, "success");
          } else if (result.code == 666) {
            // Manejo de sesión o token
          } else {
            UturuncoUtils.showToas(result.msg, "error");
          }
        } catch (error) {
          console.error("Error al actualizar venta:", error);
          UturuncoUtils.showToas("Error al actualizar estado del pago.", "error");
        }
      }
    });
  }
}
